/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import './ManageMyInsuranceDashboard.scss';

import React, { useEffect, useState } from 'react';
import type { Match, RouterHistory } from 'react-router-dom';

import AnimatedSpinner from '../../components/AnimatedSpinner/AnimatedSpinner';
import { getUserProfile } from '../../services/profile';
import type { UserProfileType } from '../../types/profile';
import ManageMyInsuranceDashboard from './ManageMyInsuranceDashboard';

interface Props {
  history: RouterHistory;
  location: Location;
  match: Match;
}

const ManageMyInsuranceDashboardWrapper = (props: Props) => {
  const className = 'c-ManageMyInsuranceDashboard';

  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (!userProfile) {
      getUserProfile().then(
        (res: UserProfileType) => {
          setUserProfile(res);
        }
      );
    }
  });

  return userProfile ?
    <ManageMyInsuranceDashboard
      {...props}
      userProfile={userProfile}
    /> : (
      <div className={`${className}__spinnerContainer`}>
        <AnimatedSpinner size="large"></AnimatedSpinner>
      </div>
    );
};

export default ManageMyInsuranceDashboardWrapper;
